import { render, staticRenderFns } from "./EditWebhook.vue?vue&type=template&id=0889792a&scoped=true"
import script from "./EditWebhook.vue?vue&type=script&lang=js"
export * from "./EditWebhook.vue?vue&type=script&lang=js"
import style0 from "./EditWebhook.vue?vue&type=style&index=0&id=0889792a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0889792a",
  null
  
)

export default component.exports